import * as Sentry from "@sentry/react";
import { useDanceStore } from "./store/useDanceStore";

export const shouldInitializeSentry = !!import.meta.env.VITE_SENTRY_DSN;

if (shouldInitializeSentry) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        showBranding: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}
